import { render, staticRenderFns } from "./url.vue?vue&type=template&id=36f27314&scoped=true&"
import script from "./url.vue?vue&type=script&lang=js&"
export * from "./url.vue?vue&type=script&lang=js&"
import style0 from "./url.vue?vue&type=style&index=0&id=36f27314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f27314",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextField,VTextarea})
